define('BayEngageReviews.View', [
    'bay_engage_reviews.tpl',
    'BayReviews.ProductData',
    'Backbone',
    'jQuery'
], function (
    bay_engage_reviews_tpl,
    ProductData,
    Backbone,
    jQuery
) {
    'use strict';

    return Backbone.View.extend({
        template: bay_engage_reviews_tpl,

        initialize: function (options) {
            this.pdp = options.pdp;
            this.payload = options.payload || {};
            this.config = options.config || {};
            this.loader = options.loader;
        },

        afterRender: function () {
            // Ask the shared loader to inject the bundle. The footer view will
            // make the same request; the loader coalesces them into one injection.
            if (this.loader && this.payload) {
                this.loader.load(this.payload, {
                    debugMode: this.config.debugMode,
                    containerId: this.config.containerId
                });
            }
        },

        destroy: function () {
            // Selectively clear product fields only; storeDomain is owned by the
            // persistent footer (Home) view and must survive this PDP view's teardown.
            if (window.brv && window.brv.commonData) {
                delete window.brv.commonData.productId;
                delete window.brv.commonData.productSku;
                delete window.brv.commonData.productName;
                delete window.brv.commonData.userId;
                delete window.brv.commonData.userName;
                delete window.brv.commonData.userEmail;
            }

            if (Backbone.View.prototype.destroy) {
                Backbone.View.prototype.destroy.apply(this, arguments);
            } else if (Backbone.View.prototype.remove) {
                Backbone.View.prototype.remove.apply(this, arguments);
            }
        },

        getContext: function () {
            var productId = '';
            var containerId = this.config.containerId || 'bayengage-reviews-widget';

            // Resolve the current product directly from the PDP component at render
            // time so the placeholders are stamped with the right product ID.
            if (this.pdp) {
                var productData = ProductData.getPdpProductData(this.pdp, this.config);
                if (productData) {
                    ProductData.applyProductData(this.payload, productData);
                    productId = productData.productId;
                }
            }

            return {
                productId: productId,
                containerId: containerId
            };
        }
    });
});
